const regFunc = /function\s?([^\(]*)?\([^\)]*\)\s?{([\w\W]+)}/;

function addCSSLink(url, callback){
    var style = document.createElement("link");
    if(callback){
        style.onload = callback;
    }
    style.href = url;
    style.rel = "stylesheet";
    style.type = "text/css";
    (document.head || document.body || document.documentElement || document).appendChild(style);
}
function addScript(url, callback){
    var script = document.createElement("script");
    if(callback){
        script.onload = callback;
    }
    script.type = "text/javascript";
    script.src = url;

    (document.head || document.body || document.documentElement || document).appendChild(script);
}
function addFunctionScriptContent(fn){
    let content = getFunctionScriptContent(fn);
    newScriptContent(content);
}
function getFunctionScriptContent(fn) {
    return regFunc.exec(fn.toString())[2];
}
function newScriptContent(content) {
    var script = document.createElement("script")
    script.type = "text/javascript";
    script.innerHTML = content;

    document.body.appendChild(script);
}
function replaceFunction(fn) {
    newScriptContent(fn.toString());
}
module.exports = {
    addCSSLink,
    addScript,
    addFunctionScriptContent,

    newScriptContent,
    replaceFunction,
    getFunctionScriptContent,
};